class Lotame {
  handleDataConsentUpdate (accountSummary, newConsentOptions) {
    const consentClientId = 14840
    const relevantConsentOption = 'tailoredAds'
    const newConsentValue = newConsentOptions[relevantConsentOption]

    if (!accountSummary || !accountSummary.account) {
      console.info(`Lotame: no account info passed - aborting Lotame update`)
      return
    }

    if (!newConsentValue) {
      console.info(`Lotame: failed to find new consent value - aborting Lotame update`)
      return
    }

    const account = accountSummary.account
    if (account.dataConsentOptions &&
        account.dataConsentOptions.hasOwnProperty(relevantConsentOption) &&
        account.dataConsentOptions[relevantConsentOption] === newConsentValue) {
      console.info(`Lotame: consent is unchanged - not sending Lotame update`)
      return
    }

    const consentObj = {
      analytics: newConsentValue,
      crossdevice: newConsentValue,
      datasharing: newConsentValue,
      targeting: newConsentValue
    }

    console.info(`Lotame: consent has been updated to ${newConsentValue} — calling Lotame`)

    // eslint-disable-next-line no-undef
    LOTCC.setConsent(function (result) {
      // nothing to do
    }, consentClientId, consentObj)
  }
}

export { Lotame }
